"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configs_1 = require("./configs");
var NCAAFConfig = {
    id: "f97d5b5f-5afd-4897-8fa1-efac592c9c96",
    name: "NCAAF",
    url: "ncaaf",
    tabName: "NCAAF",
    icon: "football",
    imagePath: "NCAA",
    key: "CFB",
    lookupKey: "ncaaf",
    favoriteLine: "spread",
    hasFGspreadPowerRating: true,
    hasTeamPowerProjectionGrades: true,
    hasFGmoneylinePowerRating: true,
    hasFGtotalPowerRating: true,
    has1HspreadPowerRating: true,
    has1HmoneylinePowerRating: true,
    has1HtotalPowerRating: true,
    has1PspreadPowerRating: false,
    has1PmoneylinePowerRating: false,
    has1PtotalPowerRating: false,
    hasPitchers: false,
    hasGoals: false,
    hasInjuries: false,
    hasNews: true,
    hasLineup: false,
    hasSchedule: true,
    hasConfiguredSchedule: true,
    hasTeamSummary: true,
    hasGameFilters: true,
    hasStadium: true,
    hasLocation: true,
    hasTeamRecord: true,
    hasApRank: true,
    hasConferenceDropdown: true,
    hasNewsInjuriesColumn: false,
    hasDraws: false,
    hasSharpData: true,
    hasTopTrendsData: true,
    hasPlayerProps: false,
    hasRecommendedBets: true,
    hasPopularEvents: true,
    isCollege: true,
    defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,5,9,15,4]}',
    defaultColumnOrder: [2, 5, 9, 15, 4],
    publicThreshold: 60,
    sharpPercentThreshold: 20,
    sharpCountThreshold: 500,
    publicCountThreshold: 500,
    trendTypes: configs_1.DEFAULT_TREND_TYPES,
    filters: [
        {
            name: "Spread",
            key: "spread",
            url: "spread",
        },
        {
            name: "Moneyline",
            key: "moneyline",
            url: "moneyline",
        },
        {
            name: "Total",
            key: "total",
            url: "totals-spread",
        },
        {
            name: "1st Half Spread",
            key: "1Hspread",
            url: "first-half-lines",
        },
        {
            name: "1st Half Moneyline",
            key: "1Hmoneyline",
            url: "first-half-moneyline",
        },
        {
            name: "1st Half Total",
            key: "1Htotal",
            url: "first-half-totals-spread",
        },
        {
            name: "2nd Half Spread",
            key: "2Hspread",
            url: "second-half-lines",
        },
        {
            name: "2nd Half Moneyline",
            key: "2Hmoneyline",
            url: "second-half-moneylines",
        },
    ],
    periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
    periodKeys: ["FG", "1H", "2H"],
    pickTypes: [
        "spread",
        "moneyline",
        "total",
        "1Hspread",
        "1Hmoneyline",
        "1Htotal",
        "2Hspread",
        "2Hmoneyline",
    ],
    conferenceList: [
        {
            name: "All Conferences",
            key: "ALL",
            url: "all",
        },
        {
            name: "Top 25",
            key: "TOP25",
            url: "top-25",
        },
        {
            name: "American Athletic",
            key: "AAC",
            url: "american-athletic",
        },
        {
            name: "Atlantic Coast",
            key: "ACC",
            url: "atlantic-coast",
        },
        {
            name: "Big 12",
            key: "B12",
            url: "big-12",
        },
        {
            name: "Big Ten",
            key: "B1G",
            url: "big-ten",
        },
        {
            name: "Conference USA",
            key: "CUSA",
            url: "conference-usa",
        },
        {
            name: "FBS Independents",
            key: "IND",
            url: "fbs-independents",
        },
        {
            name: "Mid-American",
            key: "MAC",
            url: "mid-american",
        },
        {
            name: "Mountain West",
            key: "MWC",
            url: "mountain-west",
        },
        {
            name: "Pac-12",
            key: "P12",
            url: "pac-12",
        },
        {
            name: "SEC",
            key: "SEC",
            url: "sec",
        },
        {
            name: "Sun Belt",
            key: "SBC",
            url: "sun-belt",
        },
    ],
};
exports.default = NCAAFConfig;

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
